import type {
  ConsoleEmailConfigApi,
  ConsoleEmailEventDefaultsResponse,
  ConsoleEmailEventsListResponse,
  ConsoleEmailQueuedSendResponse,
  ConsoleEmailSuppressionApi,
  ConsoleEmailTemplateApi,
} from "@redipos/contracts";
import { http } from "../../shared/http.js";

export const plataformaApi = {
  emailConfig: () => http.get<ConsoleEmailConfigApi>("/admin/plataforma/email/config"),
  updateEmailConfig: (body: unknown) =>
    http.put<ConsoleEmailConfigApi>("/admin/plataforma/email/config", body),
  emailEventDefaults: () => http.get<ConsoleEmailEventDefaultsResponse>("/admin/plataforma/email/event-defaults"),
  updateEmailEventDefaults: (enabledJson: unknown) =>
    http.put<ConsoleEmailEventDefaultsResponse>("/admin/plataforma/email/event-defaults", { enabledJson }),
  emailTemplates: () => http.get<ConsoleEmailTemplateApi[]>("/admin/plataforma/email/templates"),
  updateEmailTemplate: (key: string, body: unknown) =>
    http.put<ConsoleEmailTemplateApi>(`/admin/plataforma/email/templates/${encodeURIComponent(key)}`, body),
  resetEmailTemplate: (key: string) =>
    http.post<ConsoleEmailTemplateApi>(`/admin/plataforma/email/templates/${encodeURIComponent(key)}/reset`, {}),
  emailEvents: (filters: Record<string, string | number | undefined | null> = {}) => {
    const params = new URLSearchParams();
    Object.entries(filters || {}).forEach(([k, v]) => {
      if (v === undefined || v === null || String(v).trim() === "") return;
      params.set(k, String(v));
    });
    if (!params.has("limit")) params.set("limit", "50");
    return http.get<ConsoleEmailEventsListResponse>(`/admin/plataforma/email/events?${params.toString()}`);
  },
  emailTestSend: (toEmail: string) =>
    http.post<ConsoleEmailQueuedSendResponse>("/admin/plataforma/email/test-send", { toEmail }),
  emailSuppressions: () => http.get<ConsoleEmailSuppressionApi[]>("/admin/plataforma/email/suppressions"),
  addEmailSuppression: (email: string, detail?: string) =>
    http.post<ConsoleEmailSuppressionApi>("/admin/plataforma/email/suppressions", { email, detail }),
  removeEmailSuppression: (email: string) =>
    http.delete<void>(`/admin/plataforma/email/suppressions/${encodeURIComponent(email)}`),

  auditLog: (filters: Record<string, string | number | undefined | null> = {}) => {
    const params = new URLSearchParams();
    Object.entries(filters || {}).forEach(([k, v]) => {
      if (v === undefined || v === null || String(v).trim() === "") return;
      params.set(k, String(v));
    });
    return http.get<AdminAuditLogRow[]>(`/admin/plataforma/audit-log?${params.toString()}`);
  },
  equipo: () => http.get<AdminTeamMemberRow[]>("/admin/plataforma/equipo"),
};

export interface AdminAuditLogRow {
  id: string;
  actorUserId: string;
  actorUsuario: string;
  action: string;
  targetType: string;
  targetId: string | null;
  metadata: Record<string, unknown> | null;
  createdAt: string;
}

export interface AdminTeamMemberRow {
  id: string;
  usuario: string;
  email: string;
  rol: string;
  isActive: boolean;
  lastLoginAt: string | null;
}
